import axios from "axios";
import moment from "moment";
const _ = require("lodash");

export default {
  updateProfileInfo(payload: any) {
    return new Promise((resolve, reject) => {
      axios
        .post("init_profile_update", payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },
  /**
   * Get Subscriber Billing informations
   * **/
  getSubscriberBillInformation: function (customerId: any) {
    return new Promise((resolve) => {
      axios
        .get("/get-bill-info", { params: { cuid: customerId } })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          resolve(error);
        });
    });
  },

  /**
   * Get ticket notes
   * of current subscriber/customer/user
   * about previously raised complains
   * **/
  getSystemNotifications: function (customerId: any, queryParams: any = {}) {
    return new Promise((resolve) => {
      let query = queryParams;
      query.cuid = customerId;
      axios
        .get("/get_system_notifications", { params: query })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          resolve(error);
        });
    });
  },

  /**
   * Get ticket notes
   * of current subscriber/customer/user
   * about previously raised complains
   * **/
  getTicketNotifications: function (customerId: any) {
    return new Promise((resolve) => {
      axios
        .get("/get_customer_ticket_notes", { params: { cuid: customerId } })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          resolve(error);
        });
    });
  },

  getMarkettingInfo: function (customerId: any) {
    return new Promise((resolve, reject) => {
      axios
        .get("get_subscriber_marketting_info", { params: { cuid: customerId } })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  getBankInfo: function (customerId: any) {
    return new Promise((resolve, reject) => {
      axios
        .get("get_bank_account_info", { params: { cuid: customerId } })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  /**
   * Get current active internet connection of a subscriber/user
   *
   * **/
  getActiveConnections: function (customerId: any) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get_active_connections", { params: { cuid: customerId } })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  /**
   * Get three better internet packages
   * from current package of a subscriber/user
   * **/
  nextBetterPackges: function (customerId: any) {
    return new Promise((resolve) => {
      axios
        .get("/get_next_better_packages", { params: { cuid: customerId } })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          resolve(error);
        });
    });
  },

  verifyOtp(url: string, payload: any) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, payload)
        .then((response) => {
          // return response.data;
          resolve(response.data);
        })
        .catch((error) => {
          // throw error.response;
          reject(error);
        });
    });
  },

  initMarkettingInfoUpdate(payload: any) {
    return new Promise((resolve, reject) => {
      axios
        .post("init_marketting_info_update", payload)
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  initBankInfoUpdate(payload: any) {
    return new Promise((resolve, reject) => {
      axios
        .post("init_bank_info_update", payload)
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  /*
   * get order status
   * of logged in subscribers
   */
  getMyOrders: function (queryParams) {
    return new Promise((resolve, reject) => {
      axios
        .get("/my_orders", { params: queryParams })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  /*
   * get my billing history
   * of logged in subscribers
   */
  getMyBillingHistory: function (queryParams) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get_billing_history", { params: queryParams })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

    /*
   * unpaid invoice payment
   * payload:
   * { invoice_id: invoiceId }
   */
    takeInvoicePayment: function (payload: any) {
      return new Promise((resolve, reject) => {
        axios
          .post("take_invoice_payment", payload)
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          });
      });
    },

    /*
   * get my billing history
   * of logged in subscribers
   */
    downloadInvoice: function (payload: any) {
      return new Promise((resolve, reject) => {
        axios
          .post("download_invoice", payload)
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          });
      });
    },

  checkLinkValidity(payload: any){
    return new Promise((resolve, reject) => {
      axios
        .post("auth/check_link_validity", payload)
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  sendCommonOtpRequest(customerId: number) {
    return new Promise((resolve, reject) => {
      axios
        .post("generate_common_otp", { id: customerId })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  verifyCommonOtp(payload: any) {
    return new Promise((resolve, reject) => {
      axios
        .post(`verify_common_otp`, payload)
        .then((response) => {
          // return response.data;
          resolve(response.data);
        })
        .catch((error) => {
          // throw error.response;
          reject(error);
        });
    });
  },

  /*
   * get my chat history
   * of logged in subscribers
   */
  getMyChatHistory: function (queryParams) {
    return new Promise((resolve, reject) => {
      axios
        .get("/get_chat_history", { params: queryParams })
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

    /*
   * get Subscriber Tickets
   * of active profile
   */
    getSubscriberTickets: function (queryParams) {
      let subscriber = '', subscriberObject = {id: null};
      subscriber = localStorage.getItem("subscriber") ?? '';
      if(subscriber != ''){
        subscriberObject = JSON.parse(subscriber);
        queryParams['cuid'] = subscriberObject ? subscriberObject.id : null;
      }

      return new Promise((resolve, reject) => {
        axios
          .get("/get-ticket", { params: queryParams })
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          });
      });
  },


  logout: function(){
    return new Promise((resolve, reject) => {
      axios
        .get("auth/logout")
        .then((response) => {
          resolve(response.data);
          //return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  buildUrl(url: string, parameters: any, mark = false) {
    var qs = "";
    for (var key in parameters) {
      var value = parameters[key];
      qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
    if (qs.length > 0) {
      qs = qs.substring(0, qs.length - 1); //chop off last "&"
      if (mark == false) {
        url = url + "?" + qs;
      } else {
        url = url + "&" + qs;
      }
    }
    return url;
  },
  getAllUsers(query = null) {
    // @ts-ignore
    let url = query && query.length >= 2 ? "all-users?q=" + query : "all-users";
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          //
        });
    });
  },

  check: function (conditions: string): any {
    let code = "" + conditions + ";";
    //console.log(code);
    return eval(code);
  },
  inArray: function (needle: any, haystack: any) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i] == needle) return true;
    }
    return false;
  },
  rtrim: function (str: any, chr: any) {
    var rgxtrim = !chr ? new RegExp("\\s+$") : new RegExp(chr + "+$");
    return str.replace(rgxtrim, "");
  },
  getInitials: function (word: any, length: any = 1) {
    return word.substring(0, length === undefined ? 1 : length);
  },
  initials: function (words: any, length: any = 1) {
    let wordsArray, initials;
    wordsArray = words === undefined ? [] : words.split(" ");

    if (length === undefined) {
      initials = wordsArray
        .map((word: any) => this.getInitials(word, length))
        .join("");
    } else {
      initials =
        wordsArray.length === 1
          ? this.getInitials(wordsArray[0], length)
          : wordsArray
              .splice(0, length)
              .map((word: any) => this.getInitials(word))
              .join("");
    }

    return initials.toUpperCase();
  },

  async fetchAccountInfo() {
    let subscriber;
    subscriber = localStorage.getItem("subscriber") || "{}";
    subscriber = JSON.parse(subscriber);
    console.log("Subscriber::", subscriber);
    return await axios
      .get("/get-account-info", { params: { cuid: subscriber.id } })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },

  async fetchPackageInfo() {
    let subscriber;
    let api_url = "/get-bill-info";
    subscriber = localStorage.getItem("subscriber") || "{}";
    subscriber = JSON.parse(subscriber);
    console.log("Subscriber::", subscriber);
    if (subscriber) {
      return await axios
        .get(api_url, { params: { cuid: subscriber.id } })
        .then((response) => {
          //console.log('response.data::', response.data);
          response.data.monthlyAmount =
            parseFloat(response.data.monthlyAmount).toLocaleString("en-US", {
              maximumFractionDigits: 2,
            });
          response.data.billDueDate = moment(response.data.billDueDate).format(
            "DD/MM/YYYY"
          );
          response.data.availableBalance =
            parseFloat(response.data.availableBalance).toLocaleString("en-US", {
              maximumFractionDigits: 2,
            });
          response.data.contractStartDate = response.data.contractStartDate ? moment(
            response.data.contractStartDate
          ).format("Do MMM YYYY") : null;
          return response.data;
        })
        .catch((error) => {
          console.log("error " + error);
          throw error.response;
        });
    }
  },
};
